import { css } from '@emotion/react';
import { UnderlinedLinkComponent } from '~/_shared/baseComponents/links';
import type { Theme } from '~/_shared/themes/theme.model';
import { useModal } from '~/modal/useModal.hook';
import {
  s, Trans,
} from '~/translations/Trans';

const trialMessageStyle = (theme: Theme) => css({
  color: theme.textColors.warning,
});

export const TrialModeWarningComponent = () => {
  const { openModal } = useModal('WMSUpgradeSubscription');

  return (
    <div css={trialMessageStyle}>
      <Trans i18nKey="TRIAL (<1>upgrade here</1>)">
        {s('TRIAL (')}
        <UnderlinedLinkComponent
          onClick={() => openModal()}
        >
          upgrade here
        </UnderlinedLinkComponent>
        {s(')')}
      </Trans>
    </div>
  );
};
